import { createFileRoute, Link } from "@tanstack/react-router";
import { loadGuideList } from "~/utils/content-fns";
import { seo, seoLinks } from "~/utils/seo";

export const Route = createFileRoute("/guides/")({
  loader: () => loadGuideList(),
  head: () => ({
    meta: seo({
      title: "Guides",
      description: "Expert guides on identity governance, access management, and security best practices.",
      url: "/guides",
    }),
    links: seoLinks({ url: "/guides" }),
  }),
  component: GuidesIndex,
});

function GuidesIndex() {
  const guides = Route.useLoaderData();
  return (
    <div className="mx-auto max-w-screen-xl px-4 py-16 md:px-8">
      <h1 className="mb-2 font-display text-4xl font-bold text-charcoal">Guides</h1>
      <p className="mb-12 font-body text-lg text-gray-60">Expert guides on identity governance, access management, and security.</p>
      <div className="grid gap-8 md:grid-cols-2 lg:grid-cols-3">
        {guides.map((g) => (
          <Link key={g.slug} to="/guides/$slug" params={{ slug: g.slug }} className="group overflow-hidden rounded-lg border border-[#DCDADA] transition-shadow hover:shadow-card">
            {g.featured_image && (
              <div className="aspect-video overflow-hidden bg-[#EBEBE9]">
                <img src={g.featured_image} alt={g.title} className="h-full w-full object-cover transition-transform duration-300 group-hover:scale-105" loading="lazy" />
              </div>
            )}
            <div className="p-5">
              {g.date && (
                <time dateTime={new Date(g.date).toISOString().slice(0, 10)} className="mb-2 block font-body text-xs uppercase tracking-wide text-gray-60">
                  {new Date(g.date).toLocaleDateString("en-US", { year: "numeric", month: "long", day: "numeric" })}
                </time>
              )}
              <h2 className="mb-2 font-body text-lg font-bold text-charcoal group-hover:text-teal-dark">{g.title}</h2>
              <p className="line-clamp-2 font-body text-sm text-gray-60">{g.description}</p>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
}
